import React from 'react'
import { createPortal } from 'react-dom'
import { IoIosClose as CloseIcon } from 'react-icons/io'

export default function Modal({ title, onClose, children, className, backgroundColor, ...props }) {
    return createPortal(
        <div className={`tw-z-[99] tw-fixed tw-top-0 tw-bottom-0 tw-left-0 ${backgroundColor ? backgroundColor : 'tw-bg-gray-600 '} tw-bg-opacity-50 tw-right-0 tw-flex tw-justify-center tw-items-center `}>
            {title && (
                <div
                    className={`tw-px-5 tw-w-full tw-mx-4 md:tw-max-h-4/6 md:tw-w-8/12 lg:tw-w-4/12 tw-bg-white tw-overflow-y-auto tw-scrollbar tw-scrollbar-hide rounded ${className}`}
                    {...props}
                >
                    <div className=" tw-py-3 tw-bg-red-200 tw-flex tw-justify-between tw-items-center">
                        {title && <h4 className="tw-text-xl tw-text-gray-600">{title}</h4>}
                        {onClose && <span onClick={onClose} className="tw-h-10 tw-w-10 tw-rounded-full tw-bg-gray-100 tw-flex tw-justify-center tw-items-center"><CloseIcon className="text-3xl text-gray-500 cursor-pointer" /></span>}
                    </div>
                    <div className="">{children}</div>
                </div>
            )}
            {!title && (
                <div className={`tw-flex-shrink-0 ${className}`} {...props}>
                    {children}
                </div>
            )}
        </div>,
        document.getElementById('modal')
    )
}
